import $ from 'jquery';
import Parallax from './Parallax';
import RemoveLink from './RemoveLink';
import RandomImage from './RandomImage';

function Banner(element) {
  this.element = element;
  this.$element = $(element);
  this.randomImage = this.addRandomImage();
  this.parallax = this.addParallax();
  this.removeLink = this.stripLink();
}

Banner.prototype = {
  addRandomImage() {
    return new RandomImage(this.element);
  },
  addParallax() {
    return new Parallax(this.element);
  },
  stripLink() {
    return new RemoveLink(this.$element.find('.node-header a'));
  },
};

export default Banner;



// WEBPACK FOOTER //
// ./Banner.js